<span *ngIf="freshnessIndicator != null" class="freshness-indicator">*{{freshnessIndicator | titlecase}}* </span>
<span class="freshness-indicator">({{commentCount}})</span>
